var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"key-value-unit"},[_c('p',{staticClass:"key-value-unit-key"},[_vm._v(_vm._s(_vm.title)+"：")]),_c('p',{staticClass:"key-value-unit-value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }